var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalInfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.511,
    height: 78.511,
    viewBox: "0 0 78.511 78.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13756",
    "data-name": "Group 13756",
    transform: "translate(-89.291 -25.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(115.765 48.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M163.725,126.03h-1.6c-4.9,0-11.921,3.307-11.921,8.832a2.6,2.6,0,0,0,2.3,2.86H173.3a2.556,2.556,0,0,0,2.453-2.652v-.221C175.746,129.337,168.721,126.03,163.725,126.03Z",
    transform: "translate(-150.19 -105.809)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M170.028,97.1a6.029,6.029,0,0,0,4.567-1.916,13.553,13.553,0,0,0,2.873-8.728,7.449,7.449,0,1,0-14.9,0,13.93,13.93,0,0,0,2.873,8.832A6.324,6.324,0,0,0,170.028,97.1Z",
    transform: "translate(-157.244 -79.009)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_653",
    "data-name": "Ellipse 653",
    cx: 7.133,
    cy: 7.133,
    r: 7.133,
    transform: "translate(121.413 25.992)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_652",
    "data-name": "Ellipse 652",
    cx: 7.133,
    cy: 7.133,
    r: 7.133,
    transform: "translate(121.413 89.237)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_653-2",
    "data-name": "Ellipse 653",
    cx: 7.133,
    cy: 7.133,
    r: 7.133,
    transform: "translate(153.036 57.614)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_652-2",
    "data-name": "Ellipse 652",
    cx: 7.133,
    cy: 7.133,
    r: 7.133,
    transform: "translate(89.791 57.614)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11221",
    "data-name": "Path 11221",
    d: "M119.467,29.89V45.242a24.594,24.594,0,0,0-10.424,10.42H93.695A38.814,38.814,0,0,1,119.467,29.89Z",
    transform: "translate(-2.225 -2.222)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11222",
    "data-name": "Path 11222",
    d: "M119.467,152.824v15.348A38.805,38.805,0,0,1,93.695,142.4h15.348A24.581,24.581,0,0,0,119.467,152.824Z",
    transform: "translate(-2.225 -66.348)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11223",
    "data-name": "Path 11223",
    d: "M231.977,142.4a38.814,38.814,0,0,1-25.772,25.772V152.824a24.6,24.6,0,0,0,10.42-10.424Z",
    transform: "translate(-66.352 -66.348)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11224",
    "data-name": "Path 11224",
    d: "M231.977,55.662H216.625a24.608,24.608,0,0,0-10.42-10.42V29.89A38.823,38.823,0,0,1,231.977,55.662Z",
    transform: "translate(-66.352 -2.222)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalInfIcon);
export default __webpack_public_path__ + "static/media/totalInfIcon.8dc01a1a3b4dbda1a7619783efe2a294.svg";
export { ForwardRef as ReactComponent };